<template>
  <div class="user_page">
    <div class="back-btn-container">
      <div @click="clearQrCodeParam">
        <back-btn />
      </div>
      <h3 class="title-page">{{ $tc("productHistory") }}</h3>
    </div>
    <div>
      <div class="admin_container">
        <div style="gap: 15px" class="mb-3 d-flex align-end search-wrapper">
          <CustomDatePicker
            v-model="options.fromDate"
            :label="$t('fromUp')"
            :name="$t('date')"
            @input="getOrdersByFilter"
            clearable
            class="user_input no-margin"
            rules="required"
          ></CustomDatePicker>
          <CustomDatePicker
            v-model="options.toDate"
            :label="$t('fromTo')"
            :name="$t('date')"
            clearable
            @input="getOrdersByFilter"
            class="user_input no-margin"
            rules="required"
          ></CustomDatePicker>
          <custom-input-text
            clearable
            style="margin-bottom: 5px"
            class="user_input no-margin pro-name"
            :placeholder="$t('productName')"
            @input="getOrdersByFilter"
            v-model="options.name"
            type="text"
          ></custom-input-text>
        </div>
        <div class="division_main">
          <div class="mb-4"></div>
          <div class="table_cover">
            <table-with-filter
              :is-filterable="false"
              fixed-header
              :items="items"
              :headers="headers"
            >
              <template #item.count="{ item: { count, changes } }">
                <div :class="{ 'notify-text': changes.includes('count') }">
                  <span class="notify-text-element">{{ Number(count) }}</span>
                </div>
              </template>
              <template #item.unit_type="{ item }">
                {{ item[`unit_type_name_${$i18n.locale}`] }}
              </template>
              <template #item.state="{ item: { state, changes } }">
                <div :class="{ 'notify-text': changes.includes('state') }">
                  <span class="notify-text-element">{{
                    $t(`productItemStatus.${state}`)
                  }}</span>
                </div>
              </template>
              <template #item.name="{ item }">
                <p>{{ item[`name_${$i18n.locale}`] }}</p>
              </template>
              <template
                #item.warehouseName="{ item: { warehouseName, changes } }"
              >
                <div :class="{ 'notify-text': changes.includes('warehouse') }">
                  <span class="notify-text-element">{{ warehouseName }}</span>
                </div>
              </template>
              <template
                #item.stillageAddress="{ item: { stillageAddress, changes } }"
              >
                <div
                  :class="{ 'notify-text': changes.includes('carriages_id') }"
                >
                  <div
                    v-html="stillageAddress.join(',')"
                    v-if="stillageAddress"
                  ></div>
                  <span v-else></span>
                </div>
              </template>
              <template
                #item.carriages_id="{
                  item,
                  /**
                   * @type Object
                   * @property carriageAddresses
                   */
                }"
              >
                <div
                  :class="{
                    'notify-text': item.changes.includes('carriages_id'),
                  }"
                >
                  <div
                    v-html="item.carriageAddresses.join(', ')"
                    v-if="item.carriageAddresses"
                  ></div>
                  <span v-else></span>
                </div>
              </template>
              <template #item.updatedDate="{ item: { updatedDate } }"
                ><span class="no-wrap-text">{{
                  updatedDate | fullTimeParse
                }}</span></template
              >
              <template #item.qrcode="{ item }">
                <span>{{ item.qrcode === "null" ? 0 : item.qrcode }}</span>
              </template>
              <template #item.productId="{ item }">
                <v-btn
                  @click="refreshItems"
                  :to="{
                    name: 'product-history',
                    query: { qrCode: item.id },
                  }"
                  class="new_style"
                >
                  <vue-icon icon="newTimeIcon"></vue-icon>
                </v-btn>
              </template>
            </table-with-filter>
          </div>
          <vue-pagination
            @update:limit="
              (limit) => {
                options.limit = limit;
                options.page = 1;
                changePage();
              }
            "
            v-model="options.page"
            :length="lastPage"
            @input="changePage"
            go-to
            :limit="options.limit"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  debounce,
  getQueryByKey,
  makerPagination,
  shallowEqual,
} from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

const DEFAULT_PRODUCT_FILTER = {
  // name: null
  qrCode: null,
  orderNumber: null,
  accountingCode: null,
  warehouseId: null,
};

export default {
  components: { VuePagination, TableWithFilter, BackBtn },
  data() {
    return {
      items: [],
      productFilter: {
        ...DEFAULT_PRODUCT_FILTER,
      },
      options: {
        id: null,
        fromDate: "",
        toDate: "",
        page: 1,
        limit: 10,
        name: "",
      },
      lastPage: 0,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("productName"),
          value: "name",
        },
        {
          text: this.$t("measureShort"),
          value: "unit_type",
        },
        {
          text: this.$t("count"),
          value: "count",
        },
        // {
        //   text: this.$t("productCode"),
        //   value: "accountingCode",
        // },
        {
          text: this.$t("warehouse"),
          value: "warehouseName",
        },
        // {
        //   text: this.$t("qrCode"),
        //   value: "qrcode",
        // },
        {
          text: this.$t("state"),
          value: "state",
        },
        {
          text: this.$t("warehouseFieldType.stillage"),
          value: "stillageAddress",
        },
        {
          text: this.$t("warehouseFieldType.carriage"),
          value: "carriages_id",
        },
        {
          text: this.$t("updatedByUser"),
          value: "updatedByUser",
        },
        {
          text: this.$t("updatedDate"),
          value: "updatedDate",
        },
      ];
    },
  },
  methods: {
    getOrdersByFilter() {
      this.showLoading();
      this.onChangeFilter();
      this.clearLoading();
    },
    async getItems() {
      try {
        this.options.id = this.$route.query.productItemId;
        this.options.productId = this.$route.query.id;
        const params = {
          ...this.options,
          ...this.productFilter,
        };
        params.page--;
        const {
          data: { data, total },
        } = await this.$http.get("history/product-items", {
          params,
        });
        this.items = data.map((item) => {
          item.show = false;
          return item;
        });
        this.lastPage = makerPagination({
          total,
          limit: params.limit,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    onChangeFilter: debounce(async function () {
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    }, 300),
    async changePage(val) {
      this.showLoading();
      await this.$router.replace({ query: { page: val } });
      await this.getItems();
      this.clearLoading();
    },
    async refreshItems() {
      const { query } = this.$route;
      if (!shallowEqual(query, this.productFilter)) {
        this.productFilter = getQueryByKey(this.productFilter, query);
        this.showLoading();
        await this.getItems();
        this.clearLoading();
      }
    },

    clearQrCodeParam() {
      this.showLoading();

      // Clear the qrCode parameter
      this.productFilter.qrCode = null;

      // Fetch items with the updated filter
      this.getItems();

      this.clearLoading();
    },
  },

  async created() {
    const { query } = this.$route;
    if (!shallowEqual(query, this.productFilter)) {
      this.productFilter = getQueryByKey(this.productFilter, query);
      this.showLoading();
      await this.getItems();
      this.clearLoading();
    }
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 500px) {
  .search-wrapper {
    flex-wrap: wrap;
    gap: 5px !important;
    .custom_input_label {
      margin-bottom: 0;
    }
    .pro-name {
      margin-top: 15px;
    }
    .user_input {
      width: 500px;
    }
  }
}
</style>
